const $ = jQuery;

$(document).ready(function() {
    if ($('.section-swapping-text').length === 0) {
        return;
    }

    const swappingTextItemsWidths = [];
    let swappingTextItemsMaxWidth = 0;
    $('.section-swapping-text span.swapping-text-text span').each(function() {
        swappingTextItemsWidths.push($(this).outerWidth());
        swappingTextItemsMaxWidth = Math.max(swappingTextItemsMaxWidth, $(this).outerWidth());
    });

    const itemHeight = parseInt($('.section-swapping-text span.swapping-text-text span#0').css('line-height'));
    $('.section-swapping-text span.swapping-text-text')
        .css('height', itemHeight)
        .css('width', $('.section-swapping-text span.swapping-text-text span#0').width() + 20);
    $('.section-swapping-text span.swapping-text-text .swapping-text-container')
        .css('width', swappingTextItemsMaxWidth + 20);

    const $swappingTextSlider = $('.section-swapping-text .swapping-text-container');
    $swappingTextSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        draggable: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1500,
        pauseOnHover: false,
        vertical: true,
    });
    $swappingTextSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $('.section-swapping-text span.swapping-text-text').animate({
            width: swappingTextItemsWidths[nextSlide] + 20,
        }, 500, 'easeOutBack');
    });
});



// WEBPACK FOOTER //
// ./src/js/swapping-text.js